<template>
    <BaseModal
        v-if="visible"
        ModalId="modalId"
        :HideModalFun="onHidden"
        :TitleWindow="title"
        :width="'40%'"
        height="auto"
        :buttons="[
            { text: $t('Shared.BtnCancel'), variant: 'secondary', action: 'Close' },
            { text: $t('Shared.Save'), variant: 'primary', action: emitEventOK }
        ]"
        @Close="close"
        @ShownModal="ShownModal"
    >
        <div>
            <b-row>
                <b-col md="12">
                    <MdEdit
                        v-bind:Label="$t('Shared.UserName')"
                        v-bind:Name="'UserId'"
                        v-bind:MaxLengthProp="45"
                        ref="inputUserName"
                        v-model="d_userName"
                        v-bind:isReadOnly="false"
                        v-bind:Id="'UserId'"
                        v-bind:TypeProp="'text'"
                        v-bind:isValid="isUserNameValid"
                        v-bind:isRequired="true"
                    >
                    </MdEdit>
                </b-col>
            </b-row>
        </div>
    </BaseModal>
</template>

<script>
import ShowMessage from '@/components/messages/ShowMessage.js';
import PatientPortalsService from '@/services/patientportals.service';

export default {
    name: 'PatientPortalChangeUsername',
    mixins: [ShowMessage],
    props: {
        visible: {
            type: Boolean,
            required: true
        },
        patientCode: {
            type: String,
            required: true
        },
        userName: {
            type: String,
            required: true
        },
        fullName: {
            type: String,
            required: true
        }
    },
    watch: {
        visible(newVal) {
            if (newVal) {
                this.$bvModal.show(this.modalId);
                this.emitCloseEvent = true;
            }
        },
        userName(newValue) {
            this.d_userName = newValue;
        }
    },
    data() {
        return {
            modalId: 'PatientPortalChangeUsernameModal',
            emitCloseEvent: false,
            isUserNameValid: true,
            d_userName: this.userName
        };
    },
    computed: {
        title() {
            return `${this.$t('PatientPortalDashboard.RightBar.ChangeUsername')}: ${
                this.patientCode
            } - ${this.fullName}`;
        }
    },
    methods: {
        resetData() {
            this.isUserNameValid = true;
            this.d_userName = '';
        },

        emitEventCancel() {
            this.emitCloseEvent = false;
            this.resetData();

            this.$emit('update:visible', false);
        },

        emitEventOK(bvModalEvent) {
            if (this.validate_required()) {
                this.changeUserName();
            } else {
                bvModalEvent.preventDefault();

                this.showMessage(
                    this.$tc('Msg.Error'),
                    this.$t('Msg.CheckRedLabeledFields'),
                    'errorAutoHide'
                );
            }
        },

        onHidden() {
            if (this.emitCloseEvent) {
                this.$emit('update:visible', false);
                this.emitCloseEvent = false;
                this.resetData();
            }
        },

        close() {
            this.emitEventCancel();
        },

        ShownModal() {
            this.$nextTick(() => {
                this.$refs.inputUserName.setFocus();
            });
        },

        validate_required() {
            this.isUserNameValid = this.d_userName.length > 0 ? true : false;
            return this.isUserNameValid;
        },

        changeUserName() {
            PatientPortalsService.changeUserName({
                userName: this.d_userName,
                patientCode: this.patientCode
            })
                .then(response => {
                    console.log(response.status);
                    if (response.status == '200') {
                        if (response.data) {
                            this.showMessage(
                                this.$t('PatientPortalDashboard.Title'),
                                this.$t('PatientPortalDashboard.UsernameChangedMessage')
                            );

                            this.$nextTick(() => {
                                this.$emit('update:visible', false);
                                this.$emit('ok', response.data);
                                this.resetData();
                            });
                        }
                    } else if (response.status == '204') {
                        this.showMessage(
                            this.$t('PatientPortalDashboard.Title'),
                            this.$t('PatientPortalDashboard.UsernameExistMessage'),
                            'error'
                        );
                    }
                })
                .catch(error => {
                    this.showResponseErrorMessage(error);
                });
        }
    }
};
</script>
